var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 219C79.9383 219 52.7205 206.832 33.0002 187.149V32.8505C52.7205 13.1683 79.9383 1 110 1C170.199 1 219 49.801 219 110C219 170.199 170.199 219 110 219Z",
    fill: "#222222",
    stroke: "#767676",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryBackground);
export default __webpack_public_path__ + "static/media/categoryBackground.5cf2a7fa1bd321e1010dfdd22dda50e3.svg";
export { ForwardRef as ReactComponent };